// extracted by mini-css-extract-plugin
export default {"SwipeLeftToClose":"bfn_a bii_bk bii_bl bii_bo","SwipeLeftToClose--animating":"bfn_b"};